import { Alert, Button, Stack } from '@mui/material';
import type { FC } from 'react';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { spAppMainPages } from '@pflegenavi/frontend/routing';
import { useGetServiceProviderPhoenix } from '@pflegenavi/service-provider-frontend/api';
import { useAuthentication } from '@pflegenavi/frontend/authentication';

const DISMISS_KEY_PREFIX = 'dismiss-bank-account-banner-';

export const BankAccountSetupBanner: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuthentication();
  const userId = user?.userId;

  const { data: serviceProvider } = useGetServiceProviderPhoenix();

  const dismissKey = userId ? `${DISMISS_KEY_PREFIX}${userId}` : null;
  const [isDismissed, setIsDismissed] = useState(() => {
    if (!dismissKey) {
      return false;
    }
    return localStorage.getItem(dismissKey) === 'true';
  });

  const handleDismiss = useCallback(() => {
    if (dismissKey) {
      localStorage.setItem(dismissKey, 'true');
      setIsDismissed(true);
    }
  }, [dismissKey]);

  const handleSetupBankAccount = useCallback(() => {
    navigate(spAppMainPages.SETUP_BANK_ACCOUNT);
  }, [navigate]);

  // Check if user has MangoPay account but no bank account
  const showBanner =
    !isDismissed &&
    serviceProvider?.data?.payment_service_provider === 'mangopay' &&
    serviceProvider?.data?.mangopay_user_id &&
    !serviceProvider?.data?.mangopay_bank_account_id;

  if (!showBanner) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      onClose={handleDismiss}
      sx={{ mb: 3 }}
      action={
        <Stack direction="row" spacing={1} alignItems="center">
          <Button
            color="inherit"
            size="small"
            variant="outlined"
            onClick={handleSetupBankAccount}
          >
            {t('service-provider-app.dashboard.setup-bank-account-button')}
          </Button>
        </Stack>
      }
    >
      {t('service-provider-app.dashboard.bank-account-setup-required')}
    </Alert>
  );
};
